import { useLingui } from "@lingui/react/macro";
import { SearchXIcon } from "@offstreetparking/design-system/icons/SearchXIcon";
import { Text } from "@offstreetparking/design-system/typography";
export const NotFoundAlert = () => {
	const { t } = useLingui();
	return (
		<div className="flex min-h-[40vh] w-full flex-col items-center justify-center gap-4">
			<div className="rounded-lg bg-white p-2">
				<SearchXIcon className="size-10" />
			</div>
			<div className="flex flex-col items-center gap-2">
				<Text weight="bold" size="2xl">
					{t`Page Not Found`}
				</Text>
				<div className="flex flex-col items-center">
					<Text intent="muted">{t`The link you entered doesn't match any active permits or events.`}</Text>
					<Text intent="muted">{t`Please check for typos or try again.`}</Text>
				</div>
			</div>
		</div>
	);
};
